var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        mobile: _vm.isMobile(_vm.$mq),
        "trial-paywall-container": _vm.onTrialPaywall
      }
    },
    [
      _c(
        "div",
        { staticClass: "paywall-features row paywall-section" },
        [
          _vm._t("heading", [
            _c("h2", [_vm._v("The full Brilliant experience")])
          ]),
          _vm._v(" "),
          _c("div", { ref: "paywallFeatures", staticClass: "container" }, [
            _c("div", [
              _c("div", { staticClass: "features free col" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "unstyled free" },
                  _vm._l(_vm.features, function(feature) {
                    return _c(
                      "li",
                      {
                        key: feature.text,
                        class: { disabled: feature.premium }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(feature.text) +
                              "\n\n                "
                          ),
                          feature.premium
                            ? _c("em", {
                                staticClass: "b-sprite-paywall-pix-blank-check"
                              })
                            : _c("em", {
                                staticClass:
                                  "b-sprite-paywall-pix-checkmark-gray"
                              })
                        ]),
                        _vm._v(" "),
                        feature.subfeatures
                          ? _c(
                              "ul",
                              { staticClass: "unstyled" },
                              _vm._l(feature.subfeatures, function(subfeature) {
                                return _c(
                                  "li",
                                  {
                                    key: subfeature.text,
                                    class: { disabled: subfeature.premium }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(subfeature.text) +
                                          "\n                    "
                                      ),
                                      feature.premium
                                        ? _c("em", {
                                            staticClass:
                                              "b-sprite-paywall-pix-blank-check"
                                          })
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "features premium col" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "unstyled" },
                  _vm._l(_vm.features, function(feature) {
                    return _c("li", { key: feature.text }, [
                      _c("span", [
                        _vm._v(
                          "\n                " +
                            _vm._s(feature.text) +
                            "\n                "
                        ),
                        _c("em", {
                          staticClass: "b-sprite-paywall-pix-checkmark"
                        })
                      ]),
                      _vm._v(" "),
                      feature.subfeatures
                        ? _c(
                            "ul",
                            { staticClass: "unstyled" },
                            _vm._l(feature.subfeatures, function(subfeature) {
                              return _c("li", { key: subfeature.text }, [
                                _c("span", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(subfeature.text) +
                                      "\n                    "
                                  ),
                                  _c("em", {
                                    staticClass:
                                      "b-sprite-paywall-pix-checkmark"
                                  })
                                ])
                              ])
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("span", { staticClass: "b-sprite-paywall-pix-hydrogen" }),
      _vm._v(" "),
      _c("div", [
        _c("h3", [_vm._v("Free")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Try a free preview of each course and new Daily Challenges in the Today tab."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("span", { staticClass: "b-sprite-paywall-pix-carbon" }),
      _vm._v(" "),
      _c("div", [
        _c("h3", [_vm._v("Premium")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n                Unlock all courses and Daily Challenges on Brilliant to supercharge your learning.\n              "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }